import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('menuModule', ['downloadMenu', 'getMenuVariations', 'getMenuVariationVersions'])
  }
}
